import "./App.css";
import React from "react";
import IndexHome from "./pages/home";
import IndexAbout from "./pages/about";
import IndexOldAbout from "./pages/about/old";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import IndexContact from "./pages/contact";
import IndexLoans from "./pages/loans";
import IndexAccount from "./pages/account";
import IndexCurrentAccount from "./pages/currentAccount";
import IndexSavingAccount from "./pages/savingsAccount";
import SavingsProducts from "./pages/savingsProducts";
import IndexMainChannels from "./pages/channels/mainChannels";
import IndexMobileBankingChannels from "./pages/channels/mobileBanking";
import IndexAgencyBankingChannels from "./pages/channels/agencyBanking";
import IndexUssdBankingChannels from "./pages/channels/ussdBanking";
import IndexPolicy from "./pages/privacy/policy";
import IndexTerms from "./pages/privacy/termsOfService";
import IndexBusinessBanking from "./pages/businessBanking";
import IndexBetaPage from "./pages/betaPage";
import IndexSchoolFeesLoan from "./pages/schoolFeesLoan";
import AppToast from "./AppToast";
import IndexBlog from "./pages/blog";
import IndexBlogPost from "./pages/blog/blogPost";
import IndexZForHer from "./pages/zForHer";
import IndexSavings from "./pages/savings";
import IndexSupport from "./pages/support";
import ScrollToTop from "./scrollTop";

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppToast />
      <Routes>
        <Route path="/" index element={<IndexHome />} />
        <Route path="contact" element={<IndexContact />} />
        <Route path="about" element={<IndexAbout />} />
        <Route path="old-about" element={<IndexOldAbout />} />
        <Route path="loans" element={<IndexLoans />} />
        <Route path="account" element={<IndexAccount />} />
        <Route path="current-account" element={<IndexCurrentAccount />} />
        <Route path="saving-account" element={<SavingsProducts />} />
        <Route path="main-channels" element={<IndexMainChannels />} />
        <Route path="mobile-banking" element={<IndexMobileBankingChannels />} />
        <Route path="agency-banking" element={<IndexAgencyBankingChannels />} />
        <Route path="ussd-banking" element={<IndexUssdBankingChannels />} />
        <Route path="privacy-policy" element={<IndexPolicy />} />
        <Route path="terms-service" element={<IndexTerms />} />
        <Route path="business-banking" element={<IndexBusinessBanking />} />
        <Route path="beta-request" element={<IndexBetaPage />} />
        <Route path="school-fees-loan" element={<IndexSchoolFeesLoan />} />
        <Route path="fixed-deposit" element={<IndexSavingAccount />} />
        <Route path="blog" element={<IndexBlog />} />
        <Route path="blog/:id/:slug" element={<IndexBlogPost />} />
        <Route path="z-for-her" element={<IndexZForHer />} />
        <Route path="savings" element={<IndexSavings />} />
        <Route path="support" element={<IndexSupport />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;

//comments:
